import {createSvgIcon} from '../create-svg-icon';

export const SegmentIcon = createSvgIcon(
  <path d="M9 18h12v-2H9v2zM3 6v2h18V6H3zm6 7h12v-2H9v2z" />
, 'SegmentOutlined');
